import React from "react";
import "./WhyWeStandOut.css";

import img1 from "../Assets/whatmakes1.png"; // replace with your image path
import img2 from "../Assets/whatmakes2.png"; // replace with your image path
import img3 from "../Assets/whatmakes3.png"; // replace with your image path
import dotPattern from "../Assets/Triangle.png"; // your dot image

const WhatMakes = () => {
  return (
    <section className="wso-section">
      <div className="wso-header">
        <h2>What Makes NewZeal<br /> Academy Unique</h2>
        <img src={dotPattern} alt="Dot pattern" className="wso-dots" />
      </div>

      <div className="wso-cards">
        <div className="wso-card">
          <img src={img1} alt="Skilled Tutors" />
          <h3>Skilled Teachers: Each English-speaking 
teacher on our team is qualified to help you 
improve by focusing on what you already 
do well and where you need to grow.</h3>
        </div>

        <div className="wso-card">
          <img src={img2} alt="Hands-On Practice" />
          <h3>Hands-On Learning: Right from day one, 
you take part in speaking exercises, 
team activities, and practical roleplays.</h3>

        </div>

        <div className="wso-card">
          <img src={img3} alt="Learn Online" />
          <h3>Convenient Options: Online classes, convenient timings and continuous batches</h3>

        </div>
      </div>
    </section>
  );
};

export default WhatMakes;
